// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"197":"81393776","226":"9838ae8c","752":"c70175a9","868":"5c2517c4"}[chunkId] + ".chunk.js";
};